import type React from 'react';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import TenderInquirySection from './TenderInquirySection';
import WorkflowStep from './WorkflowStep';

const TenderInquiryStep: React.FC = () => {
  const { tender, validTenderId, openStep, setOpenStep } = useTenderDetails();

  return (
    <WorkflowStep
      stepNumber={2}
      expanded={openStep === 2}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 2 : null)}
      title={tender.isGrant ? 'Grant Inquiry' : 'Tender Inquiry'}
      description={`Ask questions about the ${tender.isGrant ? 'grant' : 'tender'} documents.`}
      isComplete={true}
      optional={true}
    >
      <TenderInquirySection tenderId={validTenderId} usedCount={tender.sectionChatCount || 0} />
    </WorkflowStep>
  );
};

export default TenderInquiryStep;
